import { Link } from "react-router-dom";

export function LogoMark() {
  return (
    <svg className="logo-mark" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <rect width="64" height="64" rx="14" />
      <circle cx="32" cy="32" r="13" fill="none" strokeWidth="6" />
      <circle cx="32" cy="32" r="5" />
    </svg>
  );
}

export function Logo({ to = "/" }: { to?: string }) {
  return (
    <Link to={to} className="logo" aria-label="TryLook home">
      <LogoMark />
      <span aria-hidden="true">
        Try<span className="logo-accent">Look</span>
      </span>
    </Link>
  );
}
